import React, { useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { FaPlus, FaTimes, FaFileDownload } from 'react-icons/fa';
import './PagamentosTab.css';

function PagamentosTab({
  paymentStartDate,
  setPaymentStartDate,
  paymentEndDate,
  setPaymentEndDate,
  paymentStatus,
  setPaymentStatus,
  showPaymentModal,
  setShowPaymentModal,
  showCommissionModal,
  setShowCommissionModal,
  invoicesError,
  paymentsLoading,
  payments,
  handleDeletePayment,
  setSelectedPayment,
  setShowPaymentInfoModal,
  handleGeneratePaymentsReport
}) {
  const [reportLoading, setReportLoading] = useState(false);
  const totalAmount = payments.reduce((sum, p) => sum + (p.amount ? parseFloat(p.amount) : 0), 0);
  return (
    <div className="pagamentos-container">
      <div className="table-actions">
        <button className="success" onClick={() => setShowPaymentModal(true)}>
          <FaPlus /> Adicionar Pagamento
        </button>
        <button className="success" onClick={() => setShowCommissionModal(true)}>
          Lançar Comissões
        </button>
      </div>
      <div className="caixa-search-filters">
        <div className="date-filters">
          <button 
            className="report-button"
            onClick={async () => {
              if (reportLoading) return;
              try {
                setReportLoading(true);
                const include = window.confirm('Incluir arquivos dos pagamentos no relatório?');
                console.log('include', include);
                const preOpened = window.open('', '_blank');
                const url = await handleGeneratePaymentsReport(include);
                if (url) {
                  if (preOpened && !preOpened.closed) {
                    preOpened.location = url;
                  } else {
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.rel = 'noopener,noreferrer';
                    link.download = 'payment_report.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
                } else {
                  if (preOpened && !preOpened.closed) preOpened.close();
                  alert('Falha ao gerar o relatório.');
                }
              } finally {
                setReportLoading(false);
              }
            }}
            disabled={reportLoading || paymentsLoading}
          >
            {reportLoading ? (
              <><ClipLoader size={14} color="#ffffff" /> Gerando...</>
            ) : (
              <><FaFileDownload /> Gerar Relatório</>
            )}
          </button>
          <div className="date-input-group">
            <label>Data Inicial:</label>
            <input
              type="date"
              value={paymentStartDate}
              onChange={(e) => setPaymentStartDate(e.target.value)}
              className="date-input"
              required
              onClick={(e) => e.target.showPicker()}
            />
          </div>
          <div className="date-input-group">
            <label>Data Final:</label>
            <input
              type="date"
              value={paymentEndDate}
              onChange={(e) => setPaymentEndDate(e.target.value)}
              className="date-input"
              required
              onClick={(e) => e.target.showPicker()}
            />
          </div>
          <div className="date-input-group">
            <label>Status:</label>
            <select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
              className="status-select"
            >
              <option value="sent">Aberta</option>
              <option value="paid">Pago</option>
            </select>
          </div>
        </div>
      </div>

      {invoicesError && <div className="error-message">{invoicesError}</div>}
      {paymentsLoading ? (
        <div className="loading-container">
          <ClipLoader size={50} color={"#4a90e2"} />
        </div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Data de vencimento</th>
                <th>Descrição</th>
                <th>Fornecedor</th>
                <th>Valor Total</th>
                <th>Deletar</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? <tr><td colSpan="6">No payments found</td></tr> : payments.map((payment) => (
                <tr 
                  key={payment.payment_id}
                  className="clickable-row"
                  onClick={() => {
                    setSelectedPayment(payment);
                    setShowPaymentInfoModal(true);
                  }}
                >
                  <td>{payment.expiration_date ? 
                    new Date(payment.expiration_date.includes('T') ? 
                      payment.expiration_date : 
                      `${payment.expiration_date}T12:00:00Z`
                    ).toLocaleDateString() : '-'}</td>
                  <td>{payment.description || '-'}</td>
                  <td>{payment.supplier || '-'}</td>
                  <td>R$ {payment.amount ? parseFloat(payment.amount).toFixed(2) : '0.00'}</td>
                  <td>
                    <button 
                      className="delete-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeletePayment(payment.payment_id);
                      }}
                    >
                      <FaTimes />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">Total</td>
                <td>R$ {totalAmount.toFixed(2)}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}

export default PagamentosTab; 